import React from "react";
import themePropTypes from "../theme-prop-types";

const Icon = ({
  showIcon,
  src,
  stylesObject,
  onClick,
  specificClass = "",
  alt
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  <span
    className={`${
      showIcon ? "icon-show-web-sdk" : "icon-hide-web-sdk"
    } ${specificClass}`}
    onClick={onClick}
  >
    <img style={stylesObject} src={src} alt={alt} />
  </span>
);

Icon.propTypes = themePropTypes.icon;

export default Icon;
